/** Malaysia site — amounts in Ringgit (RM) */
export const SITE = {
  currencyCode: 'MYR',
  currencySymbol: 'RM',
  defaultLanguage: 'mm',
  phonePlaceholder: '01xxxxxxxxx',
  minDeposit: 10,
  minWithdraw: 50,
};

export default SITE;
